export default {
  trigger: 'Inviter le propriétaire du restaurant',
  title: 'Inviter le propriétaire du restaurant',
  description:
    'Créez un compte pour le propriétaire du restaurant. Il recevra un e-mail avec un mot de passe temporaire pour se connecter et finaliser la configuration de son restaurant.',
  fields: {
    first_name: 'Prénom',
    last_name: 'Nom',
    email: 'E-mail',
  },
  buttons: {
    invite: "Envoyer l'invitation",
    cancel: 'Annuler',
  },
  toasts: {
    invited: '{{email}} a été invité(e) à finaliser la configuration.',
    failed: 'Impossible de créer le compte propriétaire. Veuillez réessayer.',
  },
};
